(ns manage.content-variant-page.targeting-value.db
  (:require [manage.content-variant-page.placeholder.db :refer [mapped-targeting-rule]]
            [re-frame.core :as rf]
            [re-posh.core :as rp]))

(rp/reg-query-sub :targeting-value/placeholder
  '[:find ?p . :in $ ?tv
    :where
    [?tk :targeting-key/targeting-value ?tv]
    [?tk :targeting-key/placeholder ?p]])

(rf/reg-event-fx :mapped-targeting-value/configure
  [(rf/inject-cofx :ds)
   (rf/inject-cofx :sub (fn [[_ p _tv]] [:placeholder/unique-macros p]))]
  (fn [{:keys [db ds] :placeholder/keys [unique-macros]} [_ p tv]]
    {:fx [[:transact (mapped-targeting-rule db ds p (keys unique-macros) tv)]]}))

(rf/reg-sub :mapped-targeting-key/targeting-values-without-rule
  ;; ideally this would be implemented using reg-query-sub, but re-posh does not
  ;; understand the 'missing?' predicate that is part of Datomic/datascript
  (fn [[_ tk]]
    (rf/subscribe [:ui.store/pull-entity [{:targeting-key/targeting-value [{:mapped-targeting-value/rule [:db/id]} :db/id]}] tk]))
  (fn [{targeting-values :targeting-key/targeting-value} _]
    (sequence (comp (remove :mapped-targeting-value/rule)
                    (map :db/id))
              targeting-values)))
